import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Observable } from "rxjs/Observable";

import {
  NgbModal,
  NgbModalRef,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { OperatorFunction } from "rxjs/interfaces";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  mergeMap,
} from "rxjs/operators";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import {
  ParentEventFromSearch,
  ParentEventFromSearchWithSelectedChildEvents,
} from "../../events-screen/event-page-models/parent-event-from-search";
import { parentEventsMocks } from "../../events-screen/parent-events-mocks/parent-events.mock";
import { NewDiscountFormState } from "../discount-models/NewDiscountFormState";
import { I18nService } from "../../../_services/i18n.service";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { UserEditPermissionLevel } from "../../users/user-management-models/user-privilege-edit-type.enum";
import { ChildEvent } from "../../events-screen/event-page-models/child-event";
import { GenericCheckBoxStatus } from "../../../common/generic-check-box-with-minus/generic-checkbox-with-minus.component";
import { fromPromise } from "rxjs/observable/fromPromise";
import { DiscountManagementService } from "../../../_services/discount-management.service";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";

@Component({
  selector: "new-discount-form-select-event-parent",
  templateUrl: "./new-discount-form-select-event-parent.component.html",
  styleUrls: [
    "../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
    "./new-discount-form-select-event-parent.component.scss",
  ],
})
export class NewDiscountFormSelectEventParentComponent
  implements AfterViewInit, OnInit
{
  @Input("newDiscountFormState")
  public newDiscountFormState$: Observable<NewDiscountFormState>;

  @Input("customStyle") public customStyle: "" | "thinner" = "";
  @Output("updateDiscountEvent")
  public updateDiscountEvent: EventEmitter<NewDiscountFormState> = new EventEmitter<NewDiscountFormState>();
  @ViewChild("resultTemplate") public resultTemplate;
  public autoCompleteInput: ElementRef;
  public searchForm: FormGroup;
  public searchFieldName: string = "searchField";
  public translations$: Observable<ITranslations>;
  public selectionStatus: GenericCheckBoxStatus =
    GenericCheckBoxStatus.AllSelected;
  @ViewChild("autoCompleteInput")
  private currentFormState: NewDiscountFormState;

  constructor(
    private modalService: NgbModal,
    private discountManagementService: DiscountManagementService,
    protected translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {
    this.searchForm = new FormGroup({});
    this.searchForm.addControl(this.searchFieldName, new FormControl(""));
    this.newDiscountFormState$.subscribe((state) => {
      this.currentFormState = state;
      this.selectionStatus =
        state &&
        state.event &&
        state.event.childEvents.every((c) => c.isSelected)
          ? GenericCheckBoxStatus.AllSelected
          : state &&
            state.event &&
            state.event.childEvents.some((c) => c.isSelected)
          ? GenericCheckBoxStatus.SomeSelected
          : GenericCheckBoxStatus.NoneSelected;
    });
  }

  public childEventRowClicked(
    event: MouseEvent,
    childEvent: ChildEvent & { isSelected: boolean }
  ) {
    event.preventDefault();
    event.stopPropagation();
    const updateChildEventCallBack = () => {
      const newState = { ...this.currentFormState, children: [] };
      const newEventState = { ...newState.event };
      newEventState.childEvents = newState.event.childEvents.map((c) => {
        return c.childEventId === childEvent.childEventId
          ? { ...childEvent, isSelected: !childEvent.isSelected }
          : { ...c };
      });
      newState.event = newEventState;
      this.updateDiscountEvent.emit(newState);
    };
    if (
      this.currentFormState.event &&
      this.currentFormState.children.length > 0
    ) {
      const warningMessage =
        "הפעולה תאפס את טופס הסבסוד וכל הנתונים שהוזנו. האם להמשיך?";
      this.modalNotification(warningMessage, () => {
        updateChildEventCallBack();
      });
      return;
    } else {
      updateChildEventCallBack();
    }
  }

  public onInputChange(
    event: Event,
    childEvent: ChildEvent & { isSelected: boolean }
  ) {
    event.preventDefault();
    event.stopPropagation();
    this.childEventRowClicked(event as any, childEvent);
    return false;
  }

  public formatDateToString(date: Date) {
    return I18nService.formatDateToString(date);
  }

  public searchHandler: OperatorFunction<string, any> = (
    text$: Observable<any>
  ) => {
    return text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      mergeMap((term): any => {
        return fromPromise(
          this.discountManagementService.searchParentEventForNewSubsidyByText(
            term
          )
        );
      })
    );
  };

  public formatter = (x: { name: string }) => x.name;

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  public submit() {}

  public getResultTemplate() {
    return this.resultTemplate;
  }

  public eventSelected($event: NgbTypeaheadSelectItemEvent) {
    $event.preventDefault();
    this.searchForm.controls[this.searchFieldName].reset(null);

    if (
      this.currentFormState.event &&
      this.currentFormState.event.parentEventId !== $event.item.parentEventId
    ) {
      const warningMessage =
        "הפעולה תאפס את טופס הסבסוד וכל הנתונים שהוזנו. האם להמשיך?";
      this.modalNotification(warningMessage, () => {
        this.updateDiscountEvent.emit({
          event: $event.item,
          children: [],
        });
      });
      return;
    }

    this.updateDiscountEvent.emit({
      event: $event.item,
      children: [],
    });
  }

  public disableClick($event, stop: boolean) {
    if (!stop) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }

  public removeEventHandler($event: MouseEvent) {
    const warningMessage =
      "הפעולה תאפס את טופס הסבסוד וכל הנתונים שהוזנו. האם להמשיך?";
    this.modalNotification(warningMessage, () => {
      this.updateDiscountEvent.emit({
        event: undefined,
        children: [],
      });
    });
  }

  public changeCheckboxStatusHandler($event: GenericCheckBoxStatus) {
    if (
      this.currentFormState.event &&
      this.currentFormState.children.length > 0
    ) {
      const warningMessage =
        "הפעולה תאפס את טופס הסבסוד וכל הנתונים שהוזנו. האם להמשיך?";
      this.modalNotification(warningMessage, () => {
        this.changeCheckboxStatusHandlerAfterModal($event);
      });
      return;
    } else {
      this.changeCheckboxStatusHandlerAfterModal($event);
    }
  }

  protected modalNotification(message: string, callOnApprove?: () => void) {
    let modalText = message.toString();

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      cancelOption: "ביטול",
      modalHeader: "איפוס הטופס",
      modalText,
      onlyApprove: false,
    };
    modalRef.result.then((res) => {
      if (res === "approve" && callOnApprove) {
        callOnApprove();
      }
    });
  }

  private changeCheckboxStatusHandlerAfterModal($event: GenericCheckBoxStatus) {
    const newState = { ...this.currentFormState, children: [] };

    switch ($event) {
      case GenericCheckBoxStatus.NoneSelected:
        this.selectionStatus = GenericCheckBoxStatus.NoneSelected;
        newState.event.childEvents = newState.event.childEvents.map((c) => ({
          ...c,
          isSelected: false,
        }));
        this.updateDiscountEvent.emit(newState);
        break;
      case GenericCheckBoxStatus.AllSelected:
        this.selectionStatus = GenericCheckBoxStatus.AllSelected;
        newState.event.childEvents = newState.event.childEvents.map((c) => ({
          ...c,
          isSelected: true,
        }));
        this.updateDiscountEvent.emit(newState);
        break;
      case GenericCheckBoxStatus.SomeSelected:
        this.selectionStatus = GenericCheckBoxStatus.SomeSelected;
        this.selectionStatus = GenericCheckBoxStatus.AllSelected;
        newState.event.childEvents = newState.event.childEvents.map((c) => ({
          ...c,
          isSelected: true,
        }));
        this.updateDiscountEvent.emit(newState);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/new-discount-form-select-event-parent/new-discount-form-select-event-parent.component.ts